import React, { useState, useEffect } from 'react';
import { getRegisteredJobSeekers, deleteJobSeekerById, exportWorkshopRegistrations } from '../../../Services/WorkshopServices';
import { Link, useHistory } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import moment from 'moment';
import { utils } from '../../../helpers/utils';
import Swal from 'sweetalert2';

export type JobSeekerData = {
    workshopRegistrationId : number;
    workshopId : number;
    name : string; 
    email : string;
    phoneNumber : string;
};

export type JobSeekerDataResponse = {
    totalRecords: number,
    gridData: JobSeekerData[],
};

export function useRegisteredJobSeekers(workshopId: number = 0){

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<JobSeekerData[]>([]);

    useEffect(() => {
        if(workshopId > 0){
            _fetchData(workshopId);
        }
    }, []);

    function _fetchData(workshopId: number){
        setIsLoading(true);
        getRegisteredJobSeekers(workshopId, false).then((result: any) => {
            setIsLoading(false);
            let response: AxiosResponse<unknown, JobSeekerDataResponse> = result as AxiosResponse;
            if (response.status === 200 && response.data) {
                let data = response.data as JobSeekerDataResponse;
                setData(data.gridData);
            }
        }, (error: any) => {
            setIsLoading(false);
            console.log(error);
        });
    }

    function handleDelete(workshopRegistrationId:number) {
        setIsLoading(true);
        deleteJobSeekerById(workshopRegistrationId, false).then((result: any) => {
            setIsLoading(false);
            let response: AxiosResponse<unknown, unknown> = result as AxiosResponse;
            if (response.status === 200) {
                _fetchData(workshopId);
            }
        }, (error: any) => {
            setIsLoading(false);
            console.log(error);
        });
    }

    function handleExport(workshopId:number) {
        setIsLoading(true);
        exportWorkshopRegistrations(workshopId, false).then((result: any) => {
            setIsLoading(false);
            let response: AxiosResponse<unknown, unknown> = result as AxiosResponse;
            if (response.status === 200 && response.data) {
                utils.DownloadBlobExcelFileWithContentDisposition(response, `JobSeekerParticipants_${moment().format('MM_dd_yyyy_HH_mm_ss')}.xlsx`);
            }else if(response.status === 204){
                Swal.fire({
                    icon: 'info',
                    title: 'No Data Available',
                    text: 'We did not found any record to export',
                  });
            }else{
                throw new Error('Fail to export JobSeekerParticipants');
            }
        }, (error: any) => {
            setIsLoading(false);
            console.log(error);
        });
    }

    return [data, isLoading, handleDelete, handleExport] as const;
}